import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import {
  ShieldCheck,
  Feather,
  Ruler,
  Sparkles,
  Factory,
  Mail,
  FileCheck2,
  Menu,
  X,
  ArrowRight,
  CheckCircle2,
  XCircle,
  Headphones,
  Scissors,
  Layers,
  Cog,
  Star,
  Flame,
  Wrench,
  PenTool,
} from "lucide-react";

/* Ícone oficial do WhatsApp (bolha + fone) — usado em todos os CTAs de WhatsApp. */
const WhatsappIcon = ({ className = "h-5 w-5" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    className={className}
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.095 3.2 5.076 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.872.118.571-.085 1.758-.719 2.006-1.413.247-.694.247-1.289.173-1.413-.074-.124-.272-.198-.57-.347zM12.05 21.785h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.511-5.26c.002-5.45 4.436-9.884 9.888-9.884a9.82 9.82 0 0 1 6.988 2.898 9.825 9.825 0 0 1 2.892 6.994c-.003 5.45-4.437 9.884-9.883 9.884zm8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z" />
  </svg>
);

const LinkedinIcon = ({ className = "h-5 w-5" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    className={className}
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
  </svg>
);

const InstagramIcon = ({ className = "h-5 w-5" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    className={className}
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
  </svg>
);
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_tecnologia-agro/artifacts/5n4o1yjf_logo01.png";
const LOGO_DARK_URL =
  "https://customer-assets.emergentagent.com/job_tecnologia-agro/artifacts/7q0jqmaw_%5BBuzas%5D%20Logo%2002.png";

const WHATSAPP_NUMBER = "5511940272123";
const WHATSAPP_MESSAGE = "Olá, quero falar com a Buzas";
const WHATSAPP_LINK = `https://api.whatsapp.com/send?phone=${WHATSAPP_NUMBER}&text=${encodeURIComponent(
  WHATSAPP_MESSAGE,
)}`;

export const CONTACT_EMAIL = "comercial@buzas.com.br";
const LINKEDIN_URL =
  "https://www.linkedin.com/company/buzas-industria-e-comercio-ltda/";
const INSTAGRAM_URL = "https://www.instagram.com/buzas_laser_service/";

const HERO_IMG = "/images/hero-drone.png";
const APP_SPRAY = "/images/corte-laser.png";
const APP_MAPPING = "/images/dobra-cnc.png";
const APP_MONITOR = "/images/usinagem.png";

const NAV_LINKS = [
  { href: "#inicio", label: "Início" },
  { href: "#solucoes", label: "Capacidades" },
  { href: "#beneficios", label: "Benefícios" },
  { href: "#faq", label: "FAQ" },
  { href: "#contato", label: "Contato" },
];

/* ----------------------------- HEADER ----------------------------- */
const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-50 w-full bg-white/90 backdrop-blur-xl transition-all ${
        scrolled ? "border-b border-slate-200 shadow-sm" : "border-b border-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-6 lg:px-8">
        <a href="#inicio" data-testid="logo-link" className="flex items-center gap-2">
          <img
            src={LOGO_URL}
            alt="Buzas"
            className="h-10 w-auto object-contain"
            data-testid="logo-image"
          />
          <span className="sr-only">Buzas</span>
        </a>

        <nav className="hidden items-center gap-8 lg:flex" aria-label="Principal">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="text-sm font-medium text-slate-700 transition-colors hover:text-[color:var(--buzas-blue)]"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href={WHATSAPP_LINK}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-whatsapp-cta"
            className="hidden items-center gap-2 rounded-md bg-[color:var(--buzas-red)] px-4 py-2 text-sm font-semibold text-white shadow-sm transition-all hover:-translate-y-px hover:bg-[color:var(--buzas-red-ink)] sm:inline-flex"
          >
            <WhatsappIcon className="h-4 w-4" />
            Falar com Especialista
          </a>

          <button
            type="button"
            aria-label={open ? "Fechar menu" : "Abrir menu"}
            onClick={() => setOpen((v) => !v)}
            data-testid="mobile-menu-toggle"
            className="inline-flex h-10 w-10 items-center justify-center rounded-md text-slate-900 hover:bg-slate-100 lg:hidden"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div
          data-testid="mobile-menu"
          className="border-t border-slate-200 bg-white lg:hidden"
        >
          <div className="mx-auto flex max-w-7xl flex-col gap-1 px-4 py-3 sm:px-6">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                className="rounded-md px-3 py-3 text-base font-medium text-slate-800 hover:bg-slate-50"
              >
                {l.label}
              </a>
            ))}
            <a
              href={WHATSAPP_LINK}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="mobile-whatsapp-cta"
              className="mt-2 inline-flex items-center justify-center gap-2 rounded-md bg-[color:var(--buzas-red)] px-4 py-3 text-sm font-semibold text-white hover:bg-[color:var(--buzas-red-ink)]"
            >
              <WhatsappIcon className="h-4 w-4" />
              Falar com Especialista
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

/* ------------------------------ HERO ------------------------------ */
const Hero = () => (
  <section
    id="inicio"
    data-testid="hero-section"
    className="buzas-section buzas-gradient-soft relative overflow-hidden"
  >
    <div className="mx-auto grid max-w-7xl items-center gap-12 px-4 py-20 sm:px-6 lg:grid-cols-12 lg:gap-16 lg:py-28 lg:px-8">
      <div className="buzas-reveal lg:col-span-6">
        <span
          data-testid="hero-eyebrow"
          className="inline-flex items-center gap-2 rounded-full bg-[color:var(--buzas-blue)] px-3 py-1.5 text-xs font-semibold uppercase tracking-widest text-white"
        >
          <Factory className="h-3.5 w-3.5 text-white" />
          Manufatura técnica para o setor de drones
        </span>
        <h1
          data-testid="hero-h1"
          className="mt-6 font-display text-4xl font-bold leading-[1.05] text-[color:var(--buzas-blue-ink)] sm:text-5xl lg:text-6xl"
        >
          Tecnologia, precisão e estrutura para o mercado de drones.
        </h1>
        <p
          data-testid="hero-subheadline"
          className="mt-6 max-w-xl text-lg leading-relaxed text-slate-600"
        >
          A Buzas desenvolve soluções metálicas sob medida para fabricantes e
          integradores do setor de drones, atendendo projetos com alta
          exigência técnica e máxima confiabilidade.
        </p>
        <p
          data-testid="hero-supporting"
          className="mt-3 max-w-xl text-base text-slate-500"
        >
          Tecnologia aplicada com eficiência e segurança.
        </p>

        <div className="mt-10 flex flex-col gap-3 sm:flex-row sm:items-center">
          <a
            href="#contato"
            data-testid="hero-whatsapp-cta"
            className="inline-flex items-center justify-center gap-2 rounded-md bg-[color:var(--buzas-red)] px-6 py-3.5 text-base font-semibold text-white shadow-sm transition-all hover:-translate-y-px hover:bg-[color:var(--buzas-red-ink)]"
          >
            <FileCheck2 className="h-5 w-5" />
            Solicitar Orçamento Técnico
          </a>
          <a
            href={WHATSAPP_LINK}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="hero-contact-cta"
            className="inline-flex items-center justify-center gap-2 rounded-md border border-slate-300 bg-white px-6 py-3.5 text-base font-semibold text-[color:var(--buzas-blue)] transition-colors hover:border-[color:var(--buzas-blue)] hover:bg-slate-50"
          >
            Falar com um Especialista em Manufatura
            <ArrowRight className="h-4 w-4" />
          </a>
        </div>
      </div>

      <div className="buzas-reveal relative lg:col-span-6">
        <div className="relative overflow-hidden rounded-sm border border-slate-200 shadow-[0_30px_60px_-30px_rgba(15,30,77,0.35)]">
          <img
            src={HERO_IMG}
            alt="Componentes metálicos sob medida para drones agrícolas"
            className="aspect-[4/3] w-full object-cover"
            data-testid="hero-image"
          />
          <div
            aria-hidden="true"
            className="pointer-events-none absolute inset-0"
            style={{
              background:
                "linear-gradient(180deg, rgba(30,58,138,0.0) 50%, rgba(15,30,77,0.18) 100%)",
            }}
          />
        </div>

        {/* Floating stat card */}
        <div
          data-testid="hero-stat-card"
          className="absolute -bottom-8 -left-2 hidden w-80 rounded-sm border border-slate-200 bg-white p-6 shadow-xl sm:left-6 sm:block"
        >
          <div className="flex items-center gap-4">
            <div className="flex h-16 w-16 items-center justify-center rounded-sm bg-[color:var(--buzas-blue)]/10">
              <Ruler className="h-10 w-10 text-[color:var(--buzas-blue)]" strokeWidth={2} />
            </div>
            <div>
              <p className="text-xs uppercase tracking-widest text-slate-500">
                Manufatura
              </p>
              <p className="font-display text-lg font-bold text-[color:var(--buzas-blue-ink)]">
                Precisão dimensional
              </p>
            </div>
          </div>
        </div>

        {/* Decorative */}
        <div
          aria-hidden="true"
          className="absolute -right-6 -top-6 hidden h-24 w-24 rounded-sm border-2 border-[color:var(--buzas-blue)]/20 lg:block"
        />
      </div>
    </div>
  </section>
);

/* ------------------------ PROBLEM / SOLUTION ---------------------- */
const ProblemSolution = () => (
  <section
    id="solucoes"
    data-testid="problem-solution-section"
    className="buzas-section bg-white"
  >
    <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8 lg:py-28">
      <div className="grid gap-6 lg:grid-cols-2 lg:gap-10">
        {/* Problem */}
        <div
          data-testid="problem-card"
          className="buzas-card rounded-sm border border-slate-200 bg-white p-8 lg:p-10"
        >
          <span className="text-xs font-semibold uppercase tracking-[0.18em] text-[color:var(--buzas-red)]">
            O problema
          </span>
          <h2 className="mt-3 font-display text-2xl font-semibold leading-tight text-[color:var(--buzas-blue-ink)] sm:text-3xl">
            Peças sem precisão comprometem todo o seu projeto de drone.
          </h2>
          <p className="mt-4 text-base leading-relaxed text-slate-600">
            Componentes fora de tolerância, materiais inadequados e fornecedores
            sem capacidade técnica geram retrabalho, atraso e falhas em
            operações aéreas de alta performance.
          </p>
          <ul className="mt-6 space-y-3 text-sm text-slate-600">
            {[
              "Tolerâncias dimensionais fora do projeto",
              "Materiais sem relação ideal entre resistência e peso",
              "Fornecedor sem capacidade para produção sob medida",
            ].map((item) => (
              <li key={item} className="flex items-center gap-3">
                <XCircle className="h-5 w-5 shrink-0 text-[color:var(--buzas-red)]" strokeWidth={2} />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Solution */}
        <div
          data-testid="solution-card"
          className="buzas-card rounded-sm border border-[color:var(--buzas-blue)]/20 bg-[color:var(--buzas-blue)] p-8 text-white lg:p-10"
        >
          <span className="text-xs font-semibold uppercase tracking-[0.18em] text-white/80">
            A solução Buzas
          </span>
          <h2 className="mt-3 font-display text-2xl font-semibold leading-tight sm:text-3xl">
            Componentes estruturais sob medida para drones agrícolas.
          </h2>
          <p className="mt-4 text-base leading-relaxed text-white/85">
            Desenvolvemos peças que suportam o rigor da operação agrícola,
            garantindo durabilidade e redução de peso para aumentar a
            autonomia das aeronaves.
          </p>
          <ul className="mt-6 space-y-3 text-sm text-white/90">
            {[
              "Fidelidade total ao seu desenho técnico",
              "Ligas otimizadas para aeroespacial e agrícola",
              "Do protótipo à produção em série",
            ].map((item) => (
              <li key={item} className="flex items-center gap-3">
                <CheckCircle2 className="h-5 w-5 shrink-0 text-white" strokeWidth={2} />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  </section>
);

/* ----------------------------- BENEFITS --------------------------- */
const Benefits = () => {
  const items = useMemo(
    () => [
      {
        icon: Feather,
        title: "Leveza",
        text: "Ligas otimizadas que reduzem o peso e aumentam a autonomia da aeronave.",
      },
      {
        icon: ShieldCheck,
        title: "Resistência",
        text: "Componentes que suportam o rigor da operação agrícola, safra após safra.",
      },
      {
        icon: Sparkles,
        title: "Acabamento técnico",
        text: "Padrão industrial aeroespacial em cada peça que sai da Buzas.",
      },
      {
        icon: Ruler,
        title: "Precisão dimensional",
        text: "Tolerâncias rigorosas para encaixe perfeito no seu projeto de drone.",
      },
    ],
    [],
  );

  return (
    <section
      id="beneficios"
      data-testid="benefits-section"
      className="buzas-section bg-slate-50"
    >
      <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8 lg:py-28">
        <div className="max-w-3xl">
          <span className="text-xs font-semibold uppercase tracking-[0.18em] text-[color:var(--buzas-blue)]">
            Benefícios
          </span>
          <h2 className="mt-3 font-display text-3xl font-semibold leading-tight text-[color:var(--buzas-blue-ink)] sm:text-4xl">
            Componentes pensados para operações aéreas de alta performance
          </h2>
        </div>

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {items.map(({ icon: Icon, title, text }) => (
            <article
              key={title}
              data-testid={`benefit-card-${title.toLowerCase().replace(/\s+/g, "-")}`}
              className="buzas-card group flex h-full flex-col items-center rounded-sm border border-slate-200 bg-white p-7 text-center"
            >
              <div className="flex h-24 w-24 items-center justify-center rounded-sm bg-[color:var(--buzas-blue)]/10 text-[color:var(--buzas-blue)]">
                <Icon className="h-14 w-14" strokeWidth={1.75} />
              </div>
              <h3 className="mt-6 font-display text-lg font-bold text-[color:var(--buzas-blue-ink)]">
                {title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">
                {text}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

/* ------------------------ FIELD APPLICATION ----------------------- */
const FieldApplication = () => {
  const items = [
    {
      icon: Scissors,
      label: "Corte a laser de alta precisão",
      img: APP_SPRAY,
      alt: "Corte a laser de chapa metálica",
      desc: "Recorte preciso de chapas metálicas com mínima zona afetada pelo calor, ideal para chassis e suportes estruturais.",
    },
    {
      icon: Layers,
      label: "Dobra CNC",
      img: APP_MAPPING,
      alt: "Dobra CNC de peças metálicas",
      desc: "Conformação repetível e fiel ao projeto, garantindo encaixe exato em estruturas complexas de drones.",
    },
    {
      icon: Cog,
      label: "Usinagem técnica",
      img: APP_MONITOR,
      alt: "Usinagem técnica de componente metálico",
      desc: "Acabamento de alta exigência em componentes críticos, com tolerâncias compatíveis com o setor aeroespacial.",
    },
  ];

  return (
    <section
      data-testid="field-application-section"
      className="buzas-section bg-white"
    >
      <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8 lg:py-28">
        <div className="grid items-end gap-10 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <span className="text-xs font-semibold uppercase tracking-[0.18em] text-[color:var(--buzas-blue)]">
              Capacidades de manufatura
            </span>
            <h2 className="mt-3 font-display text-3xl font-bold leading-tight text-[color:var(--buzas-blue-ink)] sm:text-4xl">
              Tecnologia industrial aplicada às suas peças
            </h2>
          </div>
          <p className="text-base leading-relaxed text-slate-600 lg:col-span-5">
            Três frentes que estruturam a fabricação dos seus componentes — do
            recorte da chapa ao acabamento técnico final.
          </p>
        </div>

        <div className="mt-14 grid gap-6 md:grid-cols-3">
          {items.map(({ icon: Icon, label, img, alt, desc }) => (
            <figure
              key={label}
              data-testid={`application-${label.toLowerCase()}`}
              className="buzas-card group overflow-hidden rounded-sm border border-slate-200 bg-white"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={img}
                  alt={alt}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.03]"
                />
                <div
                  aria-hidden="true"
                  className="absolute inset-0"
                  style={{
                    background:
                      "linear-gradient(180deg, rgba(15,30,77,0) 55%, rgba(15,30,77,0.55) 100%)",
                  }}
                />
                <span className="absolute left-4 top-4 inline-flex items-center gap-2 rounded-full bg-white/95 px-3 py-1 text-xs font-bold text-[color:var(--buzas-blue-ink)] shadow-sm">
                  <Icon className="h-3.5 w-3.5 text-[color:var(--buzas-blue)]" />
                  {label}
                </span>
              </div>
              <figcaption className="px-6 py-5">
                <p className="font-display text-lg font-bold text-[color:var(--buzas-blue-ink)]">
                  {label}
                </p>
                <p className="mt-2 text-sm leading-relaxed text-slate-600">
                  {desc}
                </p>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

/* ---------------------------- TRUST / PROOF ----------------------- */
const Trust = () => {
  const badges = [
    {
      icon: Flame,
      label: "Soldagem especializada",
      sub: "União estrutural com padrão industrial para estruturas críticas de drones.",
    },
    {
      icon: Wrench,
      label: "Caldeiraria leve",
      sub: "Conjuntos metálicos de alta resistência com foco em redução de peso.",
    },
    {
      icon: PenTool,
      label: "Peças personalizadas",
      sub: "Fabricamos com base no seu desenho técnico, com fidelidade total ao projeto.",
    },
    {
      icon: Headphones,
      label: "Suporte contínuo",
      sub: "Acompanhamento técnico do protótipo à produção em série.",
    },
  ];

  return (
    <section
      data-testid="trust-section"
      className="buzas-section relative bg-slate-50"
    >
      <div className="buzas-grid-bg absolute inset-0 opacity-60" aria-hidden="true" />
      <div className="relative mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8 lg:py-28">
        <div className="grid gap-12 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-5">
            <span className="text-xs font-semibold uppercase tracking-[0.18em] text-[color:var(--buzas-blue)]">
              Confiança industrial
            </span>
            <h2 className="mt-3 font-display text-3xl font-bold leading-tight text-[color:var(--buzas-blue-ink)] sm:text-4xl">
              A infraestrutura metálica que impulsiona o agronegócio brasileiro
            </h2>

            <div
              data-testid="trust-rating"
              className="mt-8 inline-flex items-center gap-3 rounded-sm border border-slate-200 bg-white px-4 py-3"
            >
              <div className="flex items-center gap-1 text-[color:var(--buzas-red)]">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Star key={i} className="h-4 w-4 fill-current" />
                ))}
              </div>
              <span className="font-display text-lg font-bold text-[color:var(--buzas-blue-ink)]">
                4.9
              </span>
              <span className="text-xs text-slate-500">
                Atendimento técnico e engenharia
              </span>
            </div>

            <p className="mt-8 text-base leading-relaxed text-slate-700">
              A Buzas fornece a infraestrutura metálica que impulsiona o
              agronegócio brasileiro, com foco em aplicação prática, padrão
              industrial e suporte contínuo aos seus projetos de drones.
            </p>
          </div>

          <div className="lg:col-span-7">
            <div className="grid gap-4 sm:grid-cols-2">
              {badges.map(({ icon: Icon, label, sub }) => (
                <div
                  key={label}
                  data-testid={`trust-badge-${label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="buzas-card flex items-start gap-4 rounded-sm border border-slate-200 bg-white p-5"
                >
                  <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-sm bg-[color:var(--buzas-blue)]/10 text-[color:var(--buzas-blue)]">
                    <Icon className="h-6 w-6" strokeWidth={1.75} />
                  </div>
                  <div>
                    <p className="font-display text-base font-bold text-[color:var(--buzas-blue-ink)]">
                      {label}
                    </p>
                    <p className="mt-1 text-sm leading-relaxed text-slate-600">
                      {sub}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

/* ----------------------------- MAIN CTA --------------------------- */
const MainCTA = () => (
  <section
    id="contato"
    data-testid="main-cta-section"
    className="buzas-section relative overflow-hidden bg-[color:var(--buzas-blue-ink)]"
  >
    <div
      aria-hidden="true"
      className="absolute inset-0"
      style={{
        background:
          "radial-gradient(60% 60% at 80% 0%, rgba(255,255,255,0.08) 0%, rgba(15,30,77,0) 70%)",
      }}
    />
    <div className="relative mx-auto grid max-w-7xl items-center gap-12 px-4 py-20 sm:px-6 lg:grid-cols-12 lg:gap-16 lg:px-8 lg:py-28">
      <div className="lg:col-span-6">
        <span className="text-xs font-semibold uppercase tracking-[0.18em] text-white/70">
          Fale com a Buzas
        </span>
        <h2 className="mt-3 font-display text-3xl font-semibold leading-tight text-white sm:text-4xl lg:text-[2.75rem]">
          Leve seu projeto de drone para o próximo nível
        </h2>
        <p className="mt-5 max-w-xl text-base leading-relaxed text-white/80">
          Envie seu projeto ou desenho técnico e receba uma análise de
          viabilidade industrial.
        </p>

        <div className="mt-10 flex flex-col gap-3 sm:flex-row">
          <a
            href="#form"
            data-testid="main-cta-whatsapp"
            className="inline-flex items-center justify-center gap-2 rounded-md bg-[color:var(--buzas-red)] px-6 py-3.5 text-base font-semibold text-white shadow-sm transition-all hover:-translate-y-px hover:bg-[color:var(--buzas-red-ink)]"
          >
            <FileCheck2 className="h-5 w-5" />
            Solicitar Orçamento Técnico
          </a>
          <a
            href={WHATSAPP_LINK}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="main-cta-contact"
            className="inline-flex items-center justify-center gap-2 rounded-md border border-white/40 bg-transparent px-6 py-3.5 text-base font-semibold text-white transition-colors hover:bg-white/10"
          >
            <WhatsappIcon className="h-5 w-5" />
            Falar com um Especialista em Manufatura
          </a>
        </div>

        <div className="mt-10 flex flex-wrap items-center gap-x-8 gap-y-3 text-sm text-white/70">
          <span className="inline-flex items-center gap-2">
            <Ruler className="h-4 w-4" /> Precisão técnica
          </span>
          <span className="inline-flex items-center gap-2">
            <Factory className="h-4 w-4" /> Manufatura especializada
          </span>
          <span className="inline-flex items-center gap-2">
            <FileCheck2 className="h-4 w-4" /> Análise de viabilidade
          </span>
        </div>
      </div>

      <div className="lg:col-span-6">
        <LeadForm />
      </div>
    </div>
  </section>
);

/* ----------------------------- LEAD FORM -------------------------- */
const LeadForm = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const onChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.phone) {
      toast.error("Preencha nome, e-mail e telefone para continuar.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/leads`, form);
      toast.success("Contato enviado. Em breve retornaremos.");
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch (err) {
      const detail =
        err?.response?.data?.detail ||
        "Não foi possível enviar. Tente novamente ou use o WhatsApp.";
      toast.error(detail);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form
      id="form"
      data-testid="lead-form"
      onSubmit={onSubmit}
      className="rounded-sm border border-white/15 bg-white p-6 shadow-2xl sm:p-8"
    >
      <div className="flex items-center gap-2">
        <FileCheck2 className="h-4 w-4 text-[color:var(--buzas-blue)]" />
        <span className="text-xs font-semibold uppercase tracking-[0.18em] text-[color:var(--buzas-blue)]">
          Orçamento técnico
        </span>
      </div>
      <h3 className="mt-2 font-display text-xl font-semibold text-[color:var(--buzas-blue-ink)]">
        Envie seu projeto e receba análise de viabilidade
      </h3>

      <div className="mt-6 space-y-4">
        <div>
          <label
            htmlFor="name"
            className="text-xs font-medium uppercase tracking-widest text-slate-600"
          >
            Nome completo
          </label>
          <Input
            id="name"
            name="name"
            value={form.name}
            onChange={onChange}
            data-testid="lead-name"
            placeholder="Seu nome"
            className="mt-1.5 h-11 rounded-sm border-slate-300 bg-white text-slate-900 focus-visible:ring-2 focus-visible:ring-[color:var(--buzas-blue)]"
            required
          />
        </div>

        <div className="grid gap-4 sm:grid-cols-2">
          <div>
            <label
              htmlFor="email"
              className="text-xs font-medium uppercase tracking-widest text-slate-600"
            >
              E-mail
            </label>
            <Input
              id="email"
              name="email"
              type="email"
              value={form.email}
              onChange={onChange}
              data-testid="lead-email"
              placeholder="voce@empresa.com.br"
              className="mt-1.5 h-11 rounded-sm border-slate-300 bg-white text-slate-900 focus-visible:ring-2 focus-visible:ring-[color:var(--buzas-blue)]"
              required
            />
          </div>
          <div>
            <label
              htmlFor="phone"
              className="text-xs font-medium uppercase tracking-widest text-slate-600"
            >
              Telefone / WhatsApp
            </label>
            <Input
              id="phone"
              name="phone"
              value={form.phone}
              onChange={onChange}
              data-testid="lead-phone"
              placeholder="(00) 00000-0000"
              className="mt-1.5 h-11 rounded-sm border-slate-300 bg-white text-slate-900 focus-visible:ring-2 focus-visible:ring-[color:var(--buzas-blue)]"
              required
            />
          </div>
        </div>

        <div>
          <label
            htmlFor="message"
            className="text-xs font-medium uppercase tracking-widest text-slate-600"
          >
            Mensagem (opcional)
          </label>
          <Textarea
            id="message"
            name="message"
            value={form.message}
            onChange={onChange}
            data-testid="lead-message"
            placeholder="Descreva brevemente o componente, volume estimado e prazo. Se possível, envie depois o desenho técnico."
            className="mt-1.5 min-h-[110px] rounded-sm border-slate-300 bg-white text-slate-900 focus-visible:ring-2 focus-visible:ring-[color:var(--buzas-blue)]"
          />
        </div>
      </div>

      <Button
        type="submit"
        disabled={loading}
        data-testid="lead-submit"
        className="mt-6 h-12 w-full rounded-sm bg-[color:var(--buzas-red)] text-base font-semibold text-white hover:bg-[color:var(--buzas-red-ink)]"
      >
        {loading ? "Enviando..." : "Solicitar Orçamento Técnico"}
      </Button>
      <p className="mt-3 text-center text-xs text-slate-500">
        Ao enviar, você concorda em ser contatado pela equipe Buzas.
      </p>
    </form>
  );
};

/* --------------------------------- FAQ ---------------------------- */
const FAQ = () => {
  const items = [
    {
      q: "A Buzas fabrica o drone completo?",
      a: "Não. Somos especialistas na fabricação de peças, componentes e estruturas metálicas sob medida para fabricantes e montadores de drones.",
    },
    {
      q: "Vocês trabalham com projetos personalizados?",
      a: "Sim. Atuamos com base no seu desenho técnico, garantindo total fidelidade às especificações de engenharia do seu projeto.",
    },
    {
      q: "Quais materiais são utilizados?",
      a: "Trabalhamos com ligas metálicas otimizadas para o setor aeroespacial e agrícola, focando sempre na relação resistência-peso.",
    },
    {
      q: "Atendem demandas de prototipagem?",
      a: "Sim. Auxiliamos desde o desenvolvimento de protótipos e provas de conceito até a produção em série.",
    },
  ];

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="buzas-section bg-white"
    >
      <div className="mx-auto grid max-w-7xl gap-12 px-4 py-20 sm:px-6 lg:grid-cols-12 lg:gap-16 lg:px-8 lg:py-28">
        <div className="lg:col-span-5">
          <span className="text-xs font-semibold uppercase tracking-[0.18em] text-[color:var(--buzas-blue)]">
            Perguntas frequentes
          </span>
          <h2 className="mt-3 font-display text-3xl font-semibold leading-tight text-[color:var(--buzas-blue-ink)] sm:text-4xl">
            Dúvidas comuns sobre fabricação de peças para drones
          </h2>
          <p className="mt-5 text-base leading-relaxed text-slate-600">
            Respostas objetivas para fabricantes e integradores que precisam
            de componentes metálicos sob medida.
          </p>
          <a
            href={WHATSAPP_LINK}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="faq-whatsapp-cta"
            className="mt-8 inline-flex items-center gap-2 text-sm font-semibold text-[color:var(--buzas-red)] hover:text-[color:var(--buzas-red-ink)]"
          >
            Não encontrou sua dúvida? Fale com um especialista em manufatura
            <ArrowRight className="h-4 w-4" />
          </a>
        </div>

        <div className="lg:col-span-7">
          <Accordion
            type="single"
            collapsible
            className="divide-y divide-slate-200 border-y border-slate-200"
            data-testid="faq-accordion"
          >
            {items.map((item, i) => (
              <AccordionItem
                key={item.q}
                value={`item-${i}`}
                className="border-b-0"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="py-6 text-left font-display text-lg font-semibold text-[color:var(--buzas-blue-ink)] hover:no-underline"
                >
                  {item.q}
                </AccordionTrigger>
                <AccordionContent
                  data-testid={`faq-content-${i}`}
                  className="pb-6 text-base leading-relaxed text-slate-600"
                >
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

/* ------------------------------- FOOTER --------------------------- */
const Footer = () => (
  <footer data-testid="site-footer">
    {/* Seção azul — navegação, contato, copyright */}
    <div className="bg-[color:var(--buzas-blue-ink)] text-white">
      <div className="mx-auto max-w-7xl px-4 pt-12 sm:px-6 lg:px-8">
        <img
          src={LOGO_DARK_URL}
          alt="Buzas"
          className="h-16 w-auto object-contain"
          data-testid="footer-logo"
        />
      </div>
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-12 sm:px-6 lg:grid-cols-12 lg:gap-16 lg:px-8">
        <div className="lg:col-span-6">
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-white/60">
            Navegação
          </p>
          <ul className="mt-4 grid grid-cols-2 gap-3 text-sm sm:max-w-md">
            {[
              { href: "#inicio", label: "Início" },
              { href: "#solucoes", label: "Capacidades" },
              { href: "#faq", label: "FAQ" },
              { href: "#contato", label: "Contato" },
            ].map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  data-testid={`footer-link-${l.label.toLowerCase()}`}
                  className="text-white/80 transition-colors hover:text-white"
                >
                  {l.label}
                </a>
              </li>
            ))}
            <li>
              <a
                href={WHATSAPP_LINK}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp"
                className="inline-flex items-center gap-2 text-white/80 transition-colors hover:text-white"
              >
                <WhatsappIcon className="h-4 w-4" />
                WhatsApp
              </a>
            </li>
          </ul>
        </div>

        <div className="lg:col-span-6">
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-white/60">
            Contato
          </p>
          <ul className="mt-4 space-y-3 text-sm text-white/80">
            <li className="flex items-center gap-2">
              <WhatsappIcon className="h-4 w-4" />
              <a
                href={WHATSAPP_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white"
              >
                WhatsApp comercial
              </a>
            </li>
            <li className="flex items-center gap-2">
              <Mail className="h-4 w-4" />
              <a
                href={`mailto:${CONTACT_EMAIL}`}
                data-testid="footer-email"
                className="hover:text-white"
              >
                {CONTACT_EMAIL}
              </a>
            </li>
            <li className="flex items-center gap-2">
              <LinkedinIcon className="h-4 w-4" />
              <a
                href={LINKEDIN_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-linkedin"
                className="hover:text-white"
              >
                LinkedIn
              </a>
            </li>
            <li className="flex items-center gap-2">
              <InstagramIcon className="h-4 w-4" />
              <a
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram"
                className="hover:text-white"
              >
                Instagram
              </a>
            </li>
            <li className="flex items-center gap-2">
              <Factory className="h-4 w-4" />
              Manufatura sob medida para drones
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-3 px-4 py-6 text-xs text-white/60 sm:flex-row sm:items-center sm:px-6 lg:px-8">
          <p data-testid="footer-copyright">
            © {new Date().getFullYear()} Buzas. Todos os direitos reservados.
          </p>
          <Link
            to="/politica-de-privacidade"
            data-testid="footer-privacy-link"
            className="transition-colors hover:text-white"
          >
            Política de Privacidade
          </Link>
          <p>Peças para drones · Corte a laser · Manufatura técnica</p>
        </div>
      </div>
    </div>
  </footer>
);

/* --------------------------- FLOATING CTA ------------------------- */
const FloatingWhatsApp = () => (
  <a
    href={WHATSAPP_LINK}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Falar no WhatsApp"
    data-testid="floating-whatsapp"
    className="fixed bottom-6 right-6 z-40 inline-flex h-14 w-14 items-center justify-center rounded-full bg-[color:var(--buzas-green)] text-white shadow-lg ring-4 ring-white transition-transform hover:-translate-y-0.5 hover:bg-emerald-700"
  >
    <WhatsappIcon className="h-6 w-6" />
  </a>
);

/* ------------------------------ PAGE ------------------------------ */
export default function Landing() {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <ProblemSolution />
        <Benefits />
        <FieldApplication />
        <Trust />
        <MainCTA />
        <FAQ />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}
